export default __webpack_public_path__ + "static/media/cregar-gif.ccfbdfb4.gif";